module.exports = __webpack_public_path__ + "static/media/key-icon-dark.23a9b7a5.svg";